import { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getDatabase, ref, onValue } from 'firebase/database';

/**
 * Vrai si l'utilisateur connecté a users/$uid/isAdmin === true dans Firebase.
 * La sécurité réelle vient des Security Rules ; ce hook ne fait que piloter
 * l'affichage de l'interface d'admin.
 */
export default function useIsAdmin() {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const auth = getAuth();
    let offDb = null;

    const offAuth = onAuthStateChanged(auth, (user) => {
      if (offDb) { offDb(); offDb = null; }
      if (!user) { setIsAdmin(false); return; }
      const db = getDatabase();
      offDb = onValue(
        ref(db, `users/${user.uid}/isAdmin`),
        (snap) => setIsAdmin(snap.val() === true),
        () => setIsAdmin(false),
      );
    });

    return () => {
      if (offDb) offDb();
      offAuth();
    };
  }, []);

  return isAdmin;
}
